import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewRoarComponent } from '../../../../components/review-content/review-roar/review-roar.component';

@Component({
  selector: 'roar-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewRoarComponent
  ],
  templateUrl: './roar-submission.component.html',
  styleUrl: './roar-submission.component.css'
})
export class RoarSubmissionComponent implements OnInit {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection5 = new EventEmitter<any>();

  currentRoarId: string | null = null;

  ngOnInit(): void {
    if (this.roarAssignmentFormData) {
      this.currentRoarId = this.roarAssignmentFormData.roar_id;
    }
  }

  submitRoarAssignment(): void {
    this.onSaveSection5.emit({});
  }

}
